export default __webpack_public_path__ + "static/media/grid.e9fecbd7.png";